export default __webpack_public_path__ + "static/media/screening.6bcb1dcc.jpg";